import { AttemptIndicator, KaseStatus } from '@/models';
import { colors } from '@/theme/variables';

export const AttemptIndicatorLabel = {
  [AttemptIndicator.ATTEMPTED]: 'Attempted',
  [AttemptIndicator.COMPLETED]: 'Completed',
};

export const KaseStatusList = {
  [KaseStatus.OPEN]: {
    label: 'Open',
    bgColor: colors.warning.main,
    color: colors.white,
  },
  [KaseStatus.WAITING_FOR_SUPERVISOR]: {
    label: 'Waiting for approval',
    bgColor: colors.primary.main,
    color: colors.white,
  },
  [KaseStatus.APPROVED_BY_SUPERVISOR]: {
    label: 'Approved',
    bgColor: colors.secondary.main,
    color: colors.white,
  },
  [KaseStatus.REJECTED]: {
    label: 'Rejected',
    bgColor: colors.error.main,
    color: colors.white,
  },
  [KaseStatus.ARCHIVED]: {
    label: 'Archived',
    bgColor: colors.itemGrey,
    color: colors.grey[80],
  },
};

export const AttemptIndicatorSelectItems = [
  {
    label: AttemptIndicatorLabel[AttemptIndicator.ATTEMPTED],
    value: AttemptIndicator.ATTEMPTED,
  },
  {
    label: AttemptIndicatorLabel[AttemptIndicator.COMPLETED],
    value: AttemptIndicator.COMPLETED,
  },
];
